import * as React from "react";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { generateVirtualAppointmentStoreData, generateVirtualAppointmentStoreByIdData } from "../../../../../v3/pages/BookAppointment/utils.js";
const useVirtualAppointment = () => {
  const { featureConfigs } = useFeatureToggles();
  const {
    appointmentBookingVirtualAppointmentTypeId,
    appointmentBookingVirtualAppointmentStoreCode
  } = featureConfigs ?? {};
  const appointmentBookingVirtualAppointmentGlobalStoreId = String(
    appointmentBookingVirtualAppointmentStoreCode
  );
  const { getLabel } = useIntl();
  const enabled = appointmentBookingVirtualAppointmentTypeId !== void 0 && appointmentBookingVirtualAppointmentStoreCode !== void 0;
  const isVirtualAppointmentStore = React.useCallback(
    (store) => store ? String(store.code) === appointmentBookingVirtualAppointmentStoreCode : false,
    [appointmentBookingVirtualAppointmentStoreCode]
  );
  const isVirtualAppointmentStoreById = React.useCallback(
    (store) => store ? store.globalStoreId === appointmentBookingVirtualAppointmentGlobalStoreId : false,
    [appointmentBookingVirtualAppointmentGlobalStoreId]
  );
  const isVirtualAppointmentType = React.useCallback(
    (type) => type ? type.id === appointmentBookingVirtualAppointmentTypeId : false,
    [appointmentBookingVirtualAppointmentTypeId]
  );
  const getStoreData = React.useCallback(
    (store, type) => {
      if (appointmentBookingVirtualAppointmentStoreCode === void 0 || !type) {
        return null;
      }
      return store ? { ...store, appointmentTypes: [type] } : generateVirtualAppointmentStoreData(
        Number(appointmentBookingVirtualAppointmentStoreCode),
        type
      );
    },
    [appointmentBookingVirtualAppointmentStoreCode]
  );
  const getStoreByIdData = React.useCallback(
    (store, type) => {
      if (appointmentBookingVirtualAppointmentGlobalStoreId === void 0 || !type) {
        return null;
      }
      return store ? { ...store, appointmentTypes: [type] } : generateVirtualAppointmentStoreByIdData(
        appointmentBookingVirtualAppointmentGlobalStoreId,
        type
      );
    },
    [appointmentBookingVirtualAppointmentGlobalStoreId]
  );
  const getAppointmentTypeData = React.useCallback(
    (type) => {
      if (appointmentBookingVirtualAppointmentTypeId === void 0) {
        return null;
      }
      return {
        ...type,
        id: appointmentBookingVirtualAppointmentTypeId,
        name: getLabel("appointments.virtualAppointment.name"),
        description: getLabel("appointments.virtualAppointment.description"),
        ageGroup: "ADULT",
        duration: type?.duration ?? {
          amount: 0,
          unit: "MINUTES"
        },
        isVisibleToCustomers: type?.isVisibleToCustomers ?? false
        // by default, virtual appointments are not visible to customers
      };
    },
    [appointmentBookingVirtualAppointmentTypeId, getLabel]
  );
  return React.useMemo(
    () => [
      {
        isVirtualAppointmentStore,
        isVirtualAppointmentStoreById,
        isVirtualAppointmentType,
        getStoreData,
        getStoreByIdData,
        getAppointmentTypeData
      },
      {
        enabled,
        globalStoreId: appointmentBookingVirtualAppointmentGlobalStoreId,
        typeId: appointmentBookingVirtualAppointmentTypeId
      }
    ],
    [
      isVirtualAppointmentStore,
      isVirtualAppointmentStoreById,
      isVirtualAppointmentType,
      getStoreData,
      getStoreByIdData,
      getAppointmentTypeData,
      enabled,
      appointmentBookingVirtualAppointmentGlobalStoreId,
      appointmentBookingVirtualAppointmentTypeId
    ]
  );
};
export {
  useVirtualAppointment as default,
  useVirtualAppointment
};
//# sourceMappingURL=use-virtual-appointment.js.map
